import { faChevronRight, faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const expandableIcon = {
	collapsed: <FontAwesomeIcon icon={faChevronRight} size="xl" />,
	expanded: <FontAwesomeIcon icon={faChevronDown} size="xl" />,
}

export default expandableIcon
